import React, { useEffect, useState } from "react";
import Slider from "@material-ui/core/Slider";
import { makeStyles } from "@material-ui/core/styles";
import CompanyCard from "./components/CompanyCard";
import { invokeApi } from "../../bl_libs/invokeApi";
import { CircularProgress } from "@material-ui/core";
import { blackBackArrowImage, filterImage } from "../../assets";
import { Alert } from "@material-ui/lab";
import { Redirect } from "react-router-dom";
import CompaniesFilter from "./components/CompaniesFilter";

function SearchFilter(props) {
  const [requestData, setRequestData] = useState();
  const [discount, setDiscount] = useState(0);
  const [companies, setCompanies] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [errMessage, setErrMessage] = React.useState("");

  const [filters, setFilters] = useState({
    price: "",
    top_ratted: false,
    range: [0, 0],
  });

  const closePopUp = () => {
    document.getElementById("close-show-all").click();
    // fetchRequestDetails();
  };

  const fetchRequestDetails = () => {
    let requestObj = {
      path: "/api/customer/customer_request_detail",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      request_id: `${props.match.params.requestId}`,
    };

    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      console.log("RESPONSE", res);

      if (res.code === 200) {
        //check and verify status of request is 1 (pending acceptance)
        //if not redirect to listing request
        if (res.request.request_timeline_status !== 1) {
          pushUrl("/dashboard/my-requests");
          return;
        }
        // set state
        setRequestData(res);
        //now fetch company list
        fetchCompanyList();
      } else {
        setIsLoading(false);
      }
    });
  };
  //fetch Active request from Api
  const fetchCompanyList = (type) => {
    let requestObj = {
      path: "/api/customer/detail_of_bided_companies",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData;
    if (type === "filter") {
      postData = {
        request_id: `${props.match.params.requestId}`,
        filter_status: "1",
        min_completed_movies: `${filters.range[0]}`,
        max_completed_movies: `${filters.range[1]}`,
        price: filters.price,
        top_rated: filters.top_ratted ? "1" : "0",
      };
    } else {
      postData = {
        request_id: `${props.match.params.requestId}`,
        filter_status: "",
        min_completed_movies: "",
        max_completed_movies: "",
        price: "",
      };
    }
    setIsLoading(true);
    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      console.log(res, "companies_list");
      if (res.code === 200) {
        setIsLoading(false);
        setCompanies(res.data);
        // set discount for showing with companies bid
        setDiscount(res.request.discount);
      } else {
        setIsLoading(false);
        setErrMessage(res.message);
      }
    });
  };

  const pushUrl = (url) => {
    props.history.push(url);
  };

  useEffect(() => {
    fetchRequestDetails();
  }, []);

  if (isLoading) {
    return (
      <section id="content-wrapper" className="content-wrapper rating-page">
        <div className="container-fluid">
          <p className="small-text-bold page-title ">
            <img
              className="pointer-point"
              src={blackBackArrowImage}
              onClick={() => props.history.goBack()}
            />
            <span>Request DETAIL</span>
          </p>
          <div className="container-fluid">
            <div className="Circular-Progress">
              <CircularProgress />
            </div>
          </div>
        </div>
      </section>
    );
  }

  // if (requestData.request.request_timeline_status !== 1) {
  //   return <Redirect to={"/dashboard/my-requests"} />;
  // }

  return (
    <>
      <section id="content-wrapper" className="content-wrapper rating-page">
        <div className="container-fluid">
          <p className="small-text-bold page-title ">
            <img
              className="pointer-point"
              src={blackBackArrowImage}
              onClick={() => props.history.goBack()}
            />
            <span>Request DETAIL</span>
          </p>
          <div className="col-12 text-right">
            <span
              className="black-color pointer-point"
              data-toggle="modal"
              data-target="#change-filter"
            >
              <img src={filterImage} />
              <span className="pl-2">Filter</span>
            </span>
          </div>
          <div className="rating-wrapper mt-40 mt-m-30">
            <div className="row">
              <div className="col-0 col-sm-2 col-md-2 col-xl-3"></div>
              <div className="col-12">
                {/* col-sm-8 col-md-8 col-xl-5 */}
                {errMessage && (
                  <Alert variant="filled" severity="error">
                    {errMessage}
                  </Alert>
                )}
                <div className="">
                  {/* form-box-wrapper */}
                  <>
                    <h5 className="text-center" id="change-filter-title">
                      COMPANIES
                    </h5>
                    <div className="text-center light-grey-text">
                      Request number #{requestData.request.id}
                    </div>

                    <div className="form-box pt-20">
                      {companies.length > 0 ? (
                        companies.map((company, i) => (
                          <div key={i}>
                            <CompanyCard
                              customer_budget={
                                requestData.request.customer_budget
                              }
                              fetchCompanyList={fetchCompanyList}
                              requestData={requestData}
                              setErrMessage={setErrMessage}
                              errMessage={errMessage}
                              pushUrl={pushUrl}
                              company={company}
                              isLoading={isLoading}
                              setIsLoading={setIsLoading}
                              discount={discount}
                            />
                          </div>
                        ))
                      ) : (
                        <div className="pt-40 text-center">
                          Hang tight, more bids should be coming your way
                          shortly
                        </div>
                      )}
                    </div>
                  </>
                </div>
              </div>
              <div className="col-0 col-sm-2 col-md-2 col-xl-4"></div>
            </div>
          </div>
        </div>
      </section>
      <CompaniesFilter
        filters={filters}
        setFilters={setFilters}
        fetchCompanyList={fetchCompanyList}
      />
    </>
  );
}
export default SearchFilter;
